export default __webpack_public_path__ + "static/life_at_01-3296773a8df7ea258f84abd9d5aa61ba.jpg";